/**
 * Quali card mostrare nella pagina Connettori (card #10340678981).
 *
 * - `web` sempre; le voci "coming soon" (available:false) restano com'erano.
 * - Le altre solo se il backend le dichiara disponibili in `availableTypes`.
 * - Eccezione: un connettore non più disponibile ma ancora attivo sul bot resta
 *   visibile con `unavailableButActive`, altrimenti nessuno potrebbe spegnerlo.
 * - `availableTypes` assente = backend che non conosce la regola: si mostra tutto.
 */
export function visibleConnectors(catalog, availableTypes, connectors) {
  const available = Array.isArray(availableTypes) ? new Set(availableTypes) : null;
  const activeTypes = new Set((connectors || []).filter((c) => c.enabled).map((c) => c.type));
  return catalog.flatMap((entry) => {
    const gated = !!available && entry.type !== 'web' && entry.available !== false;
    const listed = !gated || available.has(entry.type);
    const active = activeTypes.has(entry.type);
    if (!listed && !active) return [];
    return [{ ...entry, unavailableButActive: gated && !listed && active }];
  });
}
